import React, { FC } from 'react';
import { SxProps } from '@mui/system';

import { TFunction } from 'Modules/core/i18n';
import { usePaginationFilters } from 'Modules/business/data';
import { Box, Stack, Typography } from 'Modules/ui3';

import { PlaceholderIcon } from '../PlaceholderIcon';


type PlaceholderProps = {
    t: TFunction;
    sx?: SxProps;
    path?: string;
    searchFilterField?: string[];
};


export const TablePlaceholder: FC<PlaceholderProps> = ({
    children, t, sx, path, searchFilterField,
}) => {
    const { filters } = usePaginationFilters(path);
    const isFilterFieldSet = searchFilterField?.some(filterField => filters?.[filterField]);

    return (
        <Stack
            spacing={isFilterFieldSet ? 2 : 8}
            alignItems='center'
            zIndex={1}
            height='100%'
            width='100%'
            justifyContent='center'
            className='acover'
            sx={{
                backgroundColor: 'grayscale.shade0',
                '& > svg': ({ spacing }) => ({
                    width: spacing(80),
                    height: spacing(80),
                }),
                ...sx,
            }}
        >
            {isFilterFieldSet ? (
                <>
                    <Typography variant='mediumHeader2'>{t('placeholder.noResult')}</Typography>
                    <Typography variant='regularBody2' color='grayscale.shade90'>{t('placeholder.noResultDescription')}</Typography>
                </>
            ) : (
                <>
                    <Box>
                        <PlaceholderIcon />
                    </Box>

                    <Stack spacing={5} alignItems='center'>
                        <Typography variant='mediumHeader2' align='center'>
                            {t('placeholder.title')}
                        </Typography>
                        <Typography variant='regularBody2' color='grayscale.shade90' align='center'>
                            {t('placeholder.description')}
                        </Typography>
                    </Stack>

                    {children}
                </>
            )}
        </Stack>
    );
};
